<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
  export default {
    name: "App",
    provide() {
      return {
        reload: this.reload
      };
    },
    data() {
      return {
        isRouterAlive: true,
        canClick: false,
        loadingAgree: false
      };
    },
    created() {
      let element = document.documentElement;
      let width = element.getBoundingClientRect().width;
      element.style.fontSize = width / 19.2 + "px";
    },

    methods: {
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true;
        });
      }
    }
  };
</script>

<style lang="scss">
  @import "./assets/scss/app";
</style>
